import { reactive } from "vue";
const context = reactive({})


export const defineColumnFilter = (name, config = { format: (v) => { return v } }) => {
    if (!name) {
        return
    }
    context[name] = config
}

export const getColumnFilter = (name) => {
    // console.log(name,context)
    return context[name]
}